import { Box, Link } from '@mui/material'
import CompliancePlip from '../../../../components/CompliancePlip'
import dayjs from 'dayjs'
import { ComplianceStatus } from '../../../../types'
import useCustomer from '../../../../hooks/useCustomer'

interface PharmaWasteProps {
  link: string
}

const PharmaWaste = ({ link }: PharmaWasteProps) => {
  const customer = useCustomer()
  const metadata = customer.customerMetadata

  return metadata && (
    <Box>
      <div className='border-box'>
        <div>
          <CompliancePlip message='' className='dashboard-compliance' status={metadata.pharma_status ?? ComplianceStatus.Inactive} />
        </div>
        <div className='compliance-message'>
          <p className='card-info'>{metadata.pharma_message_long}</p>
          <Link className='small-text' href={link}>{metadata.pharma_status === ComplianceStatus.Inactive ? 'Learn More' : 'View Details'}</Link>
        </div>
      </div>
      <div className='card-footer flex justify-between'>
        {metadata.pharma_available_containers > 0 && (
          <div className="center-text">
            <span className="block text-ot-dashboard">{metadata.pharma_available_containers}</span>
            <span className="text-base">In Use</span>
          </div>
        )}
        {metadata.pharma_processed_containers > 0 && (
          <div className="center-text">
            <span className="block text-lg">{metadata.pharma_processed_containers}</span>
            <span className="text-base">Processed</span>
          </div>
        )}
        {metadata.pharma_last_processed_date && (
          <div className="center-text">
            <span className="block text-lg">{dayjs(metadata.pharma_last_processed_date).format('MMM D, YYYY')}</span>
            <span className="text-base">Last Activity</span>
          </div>
        )}
      </div>
    </Box>
  )
}

export default PharmaWaste